import React, {Component} from 'react';
import styled from 'styled-components';
import {Input} from "../Kit/Kit";

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const TextArea = Input.withComponent('textarea').extend`
  height: 220px;
`;

class InputField extends Component {
    renderTextArea() {
        const {name, placeholder, value, required, onChange} = this.props;
        return (
          <TextArea
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            required={required}
          />
        );
    }

    renderTextInput() {
        const {name, type, placeholder, value, onChange, required} = this.props;
        return (
          <Input
            name={name}
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={onChange}
            required={required}
          />
        );
    }

    render() {
        const {label, hint, type, className} = this.props;
        return (
          <Container className={className}>
              {type === 'textarea' ? this.renderTextArea() : this.renderTextInput()}
          </Container>
        )
    }
}

export default InputField;


// WEBPACK FOOTER //
// ./src/components/InputField/InputField.js